export enum PeriodInYears {
  YEARS = 'Jahre',
  YEAR = 'Jahr',
}
